import { twMerge } from "@/lib/twMerge";

/** Marks a capability with an open ambiguity: a question mark in a circle, in the warning
 * colour — it's an unresolved question, not an error. Inline SVG (stroke follows the text
 * colour), so no icon library is needed. Labelled for screen readers and titled for hover. */
export function AmbiguityIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      role="img"
      aria-label="Has an open ambiguity"
      className={twMerge("inline-block h-4 w-4 shrink-0 text-warn", className)}
    >
      <title>Has an open ambiguity</title>
      <circle cx="12" cy="12" r="10" />
      <path d="M9.1 9a3 3 0 0 1 5.8 1c0 2-3 3-3 3" />
      <path d="M12 17h.01" />
    </svg>
  );
}
